// extracted by mini-css-extract-plugin
export default {"container":"style_container__w5Q+e","titleRow":"style_titleRow__a0KNO","leaderboardTable":"style_leaderboardTable__lGU1O","clickableHeader":"style_clickableHeader__+1eXw"};